import Vue from 'vue'
import App from './App.vue'
import './global.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false

document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });
document.addEventListener('keydown', function(e) {
    if (e.key === 'F12') {
      e.preventDefault();
    }
  });  

new Vue({
    render: h => h(App)
}).$mount('#app')